import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Box, Tooltip, Fab } from '@mui/material';
import { styled } from '@mui/material/styles';
import AddIcon from '@mui/icons-material/Add';

import { plPL } from '@mui/x-data-grid';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { DataGridToolbar } from '../../../../components/data-grid/DataGridToolbar';
import AvailabilityStatusDetails from './AvailabilityStatusDetails';
import { availabilityStatusColumns } from '../../../../services/column-definitions';

const RootStyle = styled('div')({
  flexGrow: 1,
  display: 'flex',
  overflow: 'hidden',
  flexDirection: 'column'
});

export const AvailabilityStatusList = props => {
  const { onOpenSidebar, hideSidebar, availabilityStatuses, queryCallback, loading, submitCallback, allSeasons, createSignal, turnOffCreateSignal, allPeriods, allPackages, allStatusChoices, allAvailabilityLevels } = props;
  const [openCompose, setOpenCompose] = React.useState(false);
  const [fullScreen, setFullScreen] = React.useState(false);
  const [editRowData, setEditRowData] = React.useState(null);

  React.useEffect(() => {
    if (createSignal) {
      setFullScreen(true);
      setOpenCompose(true);
      setEditRowData(null);
      turnOffCreateSignal();
    }
  }, [createSignal]);

  const handleDetailsCheck = (data, doubleClick = false) => {
    setEditRowData(data);
    if (doubleClick) {
      setFullScreen(true);
    }
    setOpenCompose(true);
  };
  const [columns, setColumns] = React.useState(availabilityStatusColumns ? availabilityStatusColumns(handleDetailsCheck) : []);

  const searchCallback = search => {
    queryCallback(search);
  };

  return (
    <RootStyle sx={{ opacity: loading ? 0.5 : 1, height: '100%' }}>
      <AvailabilityStatusDetails
        isOpenCompose={openCompose}
        parentFullScreen={fullScreen}
        onCloseCompose={() => {
          setOpenCompose(false);
          setFullScreen(false);
          setEditRowData(null);
        }}
        submitCallback={submitCallback}
        data={editRowData}
        allSeasons={allSeasons}
        allPeriods={allPeriods}
        allPackages={allPackages}
        allStatusChoices={allStatusChoices}
        allAvailabilityLevels={allAvailabilityLevels}
      />
      <Box display="flex" justifyContent="center">
        <Tooltip title="Dodaj status dostępności" sx={{ mb: 1 }}>
          <Fab
            color="primary"
            aria-label="add"
            onClick={() => {
              setFullScreen(true);
              setOpenCompose(true);
            }}
          >
            <AddIcon style={{ fontSize: '30px' }} />
          </Fab>
        </Tooltip>
      </Box>

      <Box sx={{ width: '100%', height: '100%' }}>
        <DataGridPro
          columns={columns}
          rows={availabilityStatuses}
          density="compact"
          disableColumnMenu={true}
          autoPageSize={false}
          rowsPerPageOptions={[10, 25, 50, 100]}
          pagination
          components={{
            Toolbar: DataGridToolbar
          }}
          componentsProps={{ toolbar: { onOpenSidebar, hideSidebar, miniView: true, searchCallback } }}
          localeText={plPL.components.MuiDataGrid.defaultProps.localeText}
          disableSelectionOnClick
          onRowDoubleClick={params => handleDetailsCheck(params.row, true)}
          onRowClick={params => {
            setEditRowData(params.row);
            setFullScreen(true);
            setOpenCompose(true);
          }}
        />
      </Box>
    </RootStyle>
  );
};
